<template lang="pug">
.form-feedback.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container(v-if="fillData")
        input.input(v-model="dataForm.feedback" autocomplete="ño" disabled required)
        label.label(:class="{ show: dataForm.feedback }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="feedback" title="ID")

      .input-container
        label.label(:class="{ show: dataForm.description }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="description" title="Descripción" :caseSensitive="true" :hideModified="true")
        textarea.input(v-model="dataForm.description" autocomplete="ño" rows="4" required :disabled="!canEdit" placeholder="Describe la mejora, el bug o la nueva característica")

      shInputList(:dataForm="dataForm" :dataOriginal="dataOriginal" title="Información adicional" property="additionals" type="text" :fillData="!canEdit")

      .input-container.arrow
        select.select(v-model="dataForm.type" autocomplete="ño" required :disabled="!canEdit")
          option(value="" disabled) Seleccionar tipo
          option(value="bug") Bug
          option(value="enhancement") Mejora
          option(value="suggestion") Sugerencia
        label.label(:class="{ show: dataForm.type }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="type" title="Tipo")

      .input-container.arrow(v-if="fillData && canEdit")
        select.select(v-model="dataForm.status" autocomplete="ño" required)
          option(value="pending") Pendiente
          option(value="in_progress") En progreso
          option(value="resolved") Resuelto
        label.label(:class="{ show: dataForm.status }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="status" title="Estado")

    shActionButton(v-if="canEdit" :isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData && canDelete")
    shDeleteButton(@delete="deleteFeedback")
</template>

<script>
import gql from '@my/graphql'
import mForm from '@/mixins/form'
import mDB from '@/mixins/db'
import gqlFeedback from '@/graphql/feedback'
import shInputList from '@/components/elements/InputList'
import shDeleteButton from '@/components/elements/DeleteButton'
import shProperty from '@/components/elements/Property'
import modals from '@my/store/modals'
import msg from '@/config/messages'
import filters from '@/config/filters'

export default {
  name: 'FormFeedback',

  mixins: [mForm, mDB],

  components: { shInputList, shDeleteButton, shProperty },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        description: '',
        additionals: [''],
        type: '',
        status: 'pending'
      },
      resolver: 'feedback',
      key: 'feedback',
      gql: gqlFeedback,
      delete: ['feedback', 'createdAt', 'updatedAt', 'createdBy', 'createdByName', 'brand', 'done']
    }
  },

  created () {
    if (this.fillData) {
      this.dataForm = this.copyObject(this.dataOriginal)
      if (!this.dataForm.additionals || !this.dataForm.additionals.length) {
        this.dataForm.additionals = ['']
      }
    }
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newFeedback()
      } else {
        this.updateFeedback()
      }
    },

    newFeedback () {
      const data = this.cleanData({
        description: this.dataForm.description,
        type: this.dataForm.type,
        additionals: this.dataForm.additionals
      })
      data.additionals = (data.additionals || []).filter(item => item && item.trim())
      this.dataForm = data
      this.newData(this.gql, this.resolver, this.key)
    },

    async updateFeedback () {
      const dataUpdate = this.dataUpdate()

      if (!dataUpdate) {
        modals.showMessage({ message: msg.message.all.NOTHING_CHANGED.message, type: 'error' })
        return
      }

      if (dataUpdate.additionals) {
        dataUpdate.additionals = dataUpdate.additionals.filter(item => item && item.trim())
      }

      const variables = {
        feedback: this.dataOriginal.feedback,
        feedbackUpdate: dataUpdate
      }

      const response = await gql.mutate(this.gql.UPDATE, variables)

      if (response) {
        const dataUpdated = response.data[`update${filters.capitalize(this.resolver)}`]
        modals.showMessage({ message: msg.message.default.UPDATED.message(dataUpdated[this.key], this.resolver) })
      }
    },

    async deleteFeedback () {
      const variables = {
        feedback: this.dataOriginal.feedback
      }

      const response = await gql.mutate(this.gql.DELETE, variables)

      if (response) {
        const dataDeleted = response.data[`delete${filters.capitalize(this.resolver)}`]
        modals.showMessage({ message: msg.message.default.DELETED.message(dataDeleted[this.key], this.resolver) })
      }
    },

    hasPermission (action) {
      try {
        const permissions = JSON.parse(this.$store.state.variables.permissionsString)
        const userPermissions = permissions[this.$store.state.user.type]
        return userPermissions && userPermissions.permissions.feedback && userPermissions.permissions.feedback[action]
      } catch (error) {
        return false
      }
    }
  },

  computed: {
    canEdit () {
      return !this.fillData || this.hasPermission('update')
    },

    canDelete () {
      return this.fillData && this.hasPermission('delete')
    }
  },

  watch: {
    dataOriginal: {
      handler () {
        if (this.fillData) {
          this.dataForm = this.copyObject(this.dataOriginal)
          if (!this.dataForm.additionals || !this.dataForm.additionals.length) {
            this.dataForm.additionals = ['']
          }
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-feedback
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/feedback/Form.vue